import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tab, useTheme } from "@mui/material"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { NavLink, useLocation } from "react-router-dom"
import { StyledGrid, StyledTabs } from "./PageTabs.styled"

export const PageTabs = ({ tabs, routeBack, children }) => {
  const [selectedPath, setPath] = useState()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up("sm"))
  const { t } = useTranslation("translation", { keyPrefix: "documents" })

  const location = useLocation()

  useEffect(() => {
    if (tabs.length > 0) {
      setPath(location.pathname)
    }
  }, [location.pathname, tabs])

  const handleChange = (_event, newValue) => {
    setPath(newValue)
  }

  const backText = tabs && tabs.length > 0 && tabs[0].title ? tabs[0].title : t("global.back", "Back")

  return tabs.length > 0 && !routeBack && selectedPath ? (
    <div style={{ width: "100%" }}>
      <StyledTabs
        value={selectedPath}
        onChange={handleChange}
        indicatorColor="primary"
        variant={"scrollable"}
        scrollButtons={matches && "auto"}>
        {tabs.map((item, index) => {
          return (
            <Tab
              key={item.title}
              component={NavLink}
              to={item.path}
              label={item.title}
              value={item.path}
              isActive={(match, location) => {
                if (!match) {
                  return false
                }
                setPath(match.url)
              }}
            />
          )
        })}
        {children}
      </StyledTabs>
    </div>
  ) : (
    <StyledGrid container direction="row" alignItems="center">
      <NavLink to={tabs[0].path}>
        <FontAwesomeIcon icon={faChevronLeft} size="xs" /> {backText}
      </NavLink>
      {children}
    </StyledGrid>
  )
}
